import React, { useContext, useRef, useEffect } from 'react';
import {
	ChangeCategoryPositionContext,
	IChangeCategoryPositionContext,
} from '../../changeCategoryPositionState/changeCategoryPositionContext';
import { Form } from 'antd';
import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './BtnBlock.module.scss';

export const BtnBlock: React.FC = () => {
	const { changeTypeOfModalWindow, setVisibleAdditionalRestaurantsModal, positionsData, typeOfModalWindow } =
		useContext<IChangeCategoryPositionContext>(ChangeCategoryPositionContext);

	const originalPositionsOrder = useRef(positionsData ? [...positionsData] : null);

	const compareOrders = () => {
		if (originalPositionsOrder.current && positionsData) {
			const updatedPositionsOrder = positionsData;

			for (let i = 0; i < originalPositionsOrder.current.length; i++) {
				if (originalPositionsOrder.current[i].id !== updatedPositionsOrder[i].id) {
					return false;
				}
			}
			return true;
		}
	};

	const isTheSameOrder = compareOrders();

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	const handleConfirm = () => {
		setVisibleAdditionalRestaurantsModal(true);
	};

	useEffect(() => {
		if (typeOfModalWindow === 'success') {
			originalPositionsOrder.current = [...positionsData];
		}
	}, [typeOfModalWindow]);

	return (
		<Form.Item>
			<div className={style.container} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="listing" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button
					className={style.saveBtn}
					theme="primaryBlue"
					onClick={handleConfirm}
					type="submit"
					disabled={isTheSameOrder}>
					<Text translationNameSpace="listing" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};
